const storeRoutes = {
  permission: '/permission-forbidden',
  storeVoucherEdit: '/storeVoucherEdit/:discountUuid',
  storeVoucherList: '/storeVoucherList',
  orderList: '/orderList',
  orderCreate: `/orderCreate/:uuid`,
  orderDetail: '/order/:uuid',
  orderShoppingCartList: '/order/shoppingCart/list',
  orderShoppingCartDetail: '/order/shoppingCart/edit/:uuid',
  orderSubscriptionBuyList: '/order/subscriptionBuy/list',
  orderSubscriptionBuyDetail: '/order/subscriptionBuy/edit/:uuid',
  orderGiftCardList: '/order/giftCard/list',
  orderGiftCardDetail: '/order/giftCard/edit/:uuid',
  simpleProductDetail: '/product/simpleProduct/:uuid',
  productSetDetail: '/product/productSet/:uuid',
  virtualProductDetail: '/product/virtualProduct/:uuid',
  storeStockEdit: '/stockEditor/:uuid?',
  inventoryEdit: '/inventory/:uuid',
  allInventory: '/allInventory/:productUuid',
  reviewEdit: '/review/:productUuid',
  communicationDetail: '/communication/:logUuid',
  reportSubscriptionDetail: '/reportSubscription/:reportSubscriptionUuid',
  reportDetail: '/report/:type/:reportUuid',
  storeProductList: '/productsList',
  inventoryList: '/inventoryList',
  storeStockList: '/stockList',
  salesChannelList: '/salesChannels',
  customerDatabaseList: '/customerDatabase',
  reviewList: '/reviewList',
  communicationList: '/communicationList',
  reportSubscriptionList: '/reportSubscriptionList',
  reportList: '/reportList',
  dashboard: '/',
  storeSettings: '/settings',
  storeFileLibraryList: '/settings/fileLibrary',
  storeFileLibraryDetail: '/settings/fileLibrary/:uuid',
  storeDetail: '/settings/storeDetails',
  storeDeveloperSetting: '/settings/developer',
  storeLinkLibraryList: '/settings/linkLibrary',
  storeLinkLibraryDetail: '/settings/linkLibrary/Edit/:uuid?',
  storeInvoice: '/settings/invoice',
  storeCurrency: '/settings/currency',
  storeProductSetting: '/settings/product',
  storeOrderSetting: '/settings/order',
  storeTaxList: '/settings/tax/list',
  storeTaxDetail: '/settings/tax/edit/:uuid?',
  storeLogistics: '/settings/logistics',
  storeLogisticsWarehouseDetail:
    '/settings/logistics/warehouselocation/setting/:uuid?',
  storeLogisticsParcelLockerDetail:
    '/settings/logistics/parcelLocker/setting/:warehouseUuid/:uuid?',
  storeLogisticsPickupLocationDetail:
    '/settings/logistics/pickuplocation/setting/:uuid?',
  storeLogisticsDeliveryMethodDetail:
    '/settings/logistics/deliveryMethod/setting/:warehouseUuid/:uuid?',
  storeLogisticsDestinationLanguagesDetail:
    '/settings/logistics/destinationLanguages/setting/:countryCode?',
  storeLogisticsCourierAccountDetail:
    '/settings/logistics/courieraccount/setting/:type/:location/:warehouseUuid/:uuid?',
  storeLogisticsPackingSlipDetail:
    '/settings/logistics/packingslip/setting/:warehouseUuid',
  storeLogisticsPackageSetting: '/settings/logistics/package/setting/:uuid?',
  storePaymentDetail: '/settings/payment/edit/:gatewayProviderCode/:uuid?',
  storePaymentList: '/settings/payment/list',
  storeLocalisation: '/settings/localisation',
  store3rdApi: '/settings/3rdPartyApi',
  storeTagManager: '/settings/tagManager',
  storeCommunicationList: '/settings/communicationsList',
  storeCommunicationGatewayDetail:
    '/settings/communicationDetail/:gateway/:channelType/:communicationUuid',
  storeCommunicationTemplateDetail:
    '/settings/communicationDetail/template/:gateway/:channelType/:communicationUuid/:templateUuid',
  storePermissionList: '/settings/permissionsList',
  storePermissionDetail: '/settings/permissionsDetail/:userUuid',
  customerList: '/customerDatabase/customerList/:customerDatabaseUuid',
  customerDetail:
    '/customerDatabase/customerDetail/:customerDatabaseUuid/:customerUuid',
  customerDatabaseSetting:
    '/customerDatabase/databaseSettings/:customerDatabaseUuid',
  customerTagList: '/customerDatabase/tagList/:customerDatabaseUuid',
  customerTagDetail: '/customerDatabase/tagEdit/:customerDatabaseUuid/:tagUuid',
};
const salesChannelRoutes = {
  contentList: '/salesChannel/content/:uuid',
  productList: '/salesChannel/products/:uuid',
  legalPageList: '/salesChannel/legalPage/list/:uuid',
  legalPageDetail: '/salesChannel/legalPage/editor/:uuid/:legalPageUuid',
  tcDetail: '/salesChannel/termsAndCondition/editor/:uuid/:TcUuid',
  tcList: '/salesChannel/termsAndCondition/list/:uuid',
  settings: '/salesChannel/settings/:uuid',
  categoryProducts: '/salesChannel/category/products/:uuid',
  collectionList: '/salesChannel/collections/list/:uuid',
  collectionDetail: '/salesChannel/collections/editor/:uuid/:collectionsUuid',
  categoryPages: '/salesChannel/category/pages/:uuid',
  flashSalesList: '/salesChannel/discounts/flashSale/list/:uuid',
  flashSalesDetail:
    '/salesChannel/discounts/flashSale/editor/:uuid/:discountUuid',
  invoiceSetting: '/salesChannel/setting/invoice/:uuid',
  digitalMarketingSetting: '/salesChannel/setting/digitalmarketing/:uuid',
  currencySetting: '/salesChannel/setting/currency/:uuid',
  logisticsSetting: '/salesChannel/setting/logistics/:uuid',
  localisationSetting: '/salesChannel/setting/localisation/:uuid',
  inventorySetting: '/salesChannel/setting/inventory/:uuid',
  languageSetting: '/salesChannel/setting/language/:uuid',
  orderSetting: '/salesChannel/setting/order/:uuid',
  cookieSetting: '/salesChannel/setting/cookies/:uuid',
  paymentSetting: '/salesChannel/setting/payment/:uuid',
  checkoutSetting: '/salesChannel/setting/checkout/:uuid',
  registrationSetting: '/salesChannel/setting/registration/:uuid',
  maintenance: '/salesChannel/maintenance/:uuid',
  logoManagementSetting: '/salesChannel/setting/logoManagement/:uuid',
  domainSetting: '/salesChannel/setting/domain/:uuid',
  domainDetailSetting: '/salesChannel/setting/domain/:uuid/:domainUuid',
  taxSetting: '/salesChannel/setting/tax/:uuid',
  directDiscountDetail:
    '/salesChannel/discounts/directDiscount/editor/:uuid/:discountUuid',
  directDiscountList: '/salesChannel/discounts/directDiscount/list/:uuid/',
  subscriptionBuyDetail:
    '/salesChannel/discounts/subscriptionBuy/editor/:uuid/:discountUuid',
  subscriptionBuyList: '/salesChannel/discounts/subscriptionBuy/list/:uuid/',
  giftPurchaseDetail:
    '/salesChannel/discounts/giftPurchase/editor/:uuid/:discountUuid',
  giftPurchaseList: '/salesChannel/discounts/giftPurchase/list/:uuid/',
  voucherList: '/salesChannel/discounts/voucher/list/:uuid/',
  voucherDetail: '/salesChannel/discounts/voucher/editor/:uuid/:discountUuid',
  promotionTagList: '/salesChannel/promotionTagList/:uuid/',
  promotionTagDetail: '/salesChannel/promotionTag/editor/:uuid/:tagUuid',
  miniProgramSetting: '/salesChannel/setting/miniProgramSetting/:uuid',
  communicationSetting: '/salesChannel/setting/communication/:uuid',
  communicationTemplate:
    '/salesChannel/setting/communication/template/:uuid/:communicationUuid/:category',
  //====
  salesChannelProductsLinkProductDetail:
    '/salesChannel/products/link/:saleChannelUuid/:salesChannelProductUuid',
  salesChannelProductContent:
    '/salesChannel/products/content/:saleChannelUuid/:salesChannelProductUuid',
  salesChannelProductCustomization:
    '/salesChannel/products/customisation/:saleChannelUuid/:salesChannelProductUuid',
  salesChannelProductAlias:
    '/salesChannel/products/alias/:saleChannelUuid/:salesChannelProductUuid',
  salesChannelProductAliasEdit:
    '/salesChannel/products/alias/:saleChannelUuid/:salesChannelProductUuid/:aliasUuid',
  //=========
  salesChannelEditorHomepage:
    '/salesChannel/editor/content/homepage/:saleChannelUuid/:contentUuid',
  salesChannelEditor404Page:
    '/salesChannel/editor/content/404/:saleChannelUuid/:contentUuid',
  salesChannelEditorProductSearch:
    '/salesChannel/editor/content/productSearch/:saleChannelUuid/:contentUuid',
  salesChannelEditorContentPageList:
    '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid',
  salesChannelContentPageEditorPage:
    '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid/:contentPageUuid',
  salesChannelEditorTabbar:
    '/salesChannel/editor/content/tabbar/:saleChannelUuid/:contentUuid',
  salesChannelEditorShoppingCartPage:
    '/salesChannel/editor/content/shoppingCart/:saleChannelUuid/:contentUuid',
  salesChannelEditorPromotion:
    '/salesChannel/editor/content/promotion/:saleChannelUuid/:contentUuid',
  salesChannelEditorProfilePage:
    '/salesChannel/editor/content/profilepage/:saleChannelUuid/:contentUuid',
  salesChannelEditorAllProductPage:
    '/salesChannel/editor/content/allProductsPage/:saleChannelUuid/:contentUuid',
  salesChannelAppearanceEditorPage:
    '/salesChannel/editor/content/appearance/:saleChannelUuid/:contentUuid',
  salesChannelEditorNavigation:
    '/salesChannel/editor/content/navigation/:saleChannelUuid/:contentUuid',
  salesChannelEditorHeader:
    '/salesChannel/editor/content/header/:saleChannelUuid/:contentUuid',
  salesChannelEditorFooter:
    '/salesChannel/editor/content/footer/:saleChannelUuid/:contentUuid',
  salesChannelEditorMegaMenu:
    '/salesChannel/editor/content/megaMenu/:saleChannelUuid/:contentUuid',
  salesChannelEditorAnimation:
    '/salesChannel/editor/content/animation/:saleChannelUuid/:contentUuid',
  salesChannelEditorButton:
    '/salesChannel/editor/content/button/:saleChannelUuid/:contentUuid',
  salesChannelEditorText:
    '/salesChannel/editor/content/text/:saleChannelUuid/:contentUuid',
};
////////////////////////////////////////////////////////////////////////
const storeDict = {
  dashboard: ['/'],
  orders: ['/orderList', '/order/*', 'orderCreate'],
  shoppingCartTemplate: [
    '/order/shoppingCart/list',
    '/order/shoppingCart/edit/*',
  ],
  giftCard: ['/order/giftCard/list', '/order/giftCard/edit/*'],
  products: [
    '/productsList',
    '/product/simpleProduct/*',
    '/product/productSet/*',
    '/product/variantProduct/*',
    '/product/virtualProduct/*',
  ],
  stockIn: ['/stockEditor', '/stockList'],
  inventory: ['/inventoryList', '/inventory/*', '/allInventory/*'],
  reviews: ['/reviewList', '/review/*'],
  vouchers: ['/storeVoucherList', '/storeVoucherEdit/*'],
  communications: ['/communicationList'],
  reportSubscriptions: ['/reportSubscriptionList'],
  reports: ['/reportList'],
  customersList: ['/customerDatabase'],
  customers: [
    '/customerDatabase/customerList/*',
    '/customerDatabase/customerDetail/*/*',
  ],
  customerDatabase: [
    '/customerDatabase/databaseSettings/*',
    '/customerDatabase/databaseSettings/*/*',
  ],
  customerTag: ['/customerDatabase/tagList/*', '/customerDatabase/tagEdit/*/*'],
  settings: ['/settings/*', '/settings'],
  salesChannels: ['/salesChannels'],
};
const salesChannelDict = {
  salesChannelContent: ['/salesChannel/content/*'],
  homepage: ['/salesChannel/editor/content/homepage/*/*'],
  allProducts: ['/salesChannel/editor/content/allProductsPage/*/*'],
  page404: ['/salesChannel/editor/content/404/*/*'],
  productSearch: ['/salesChannel/editor/content/productSearch/*/*'],
  contentPage: [
    '/salesChannel/editor/content/contentPage/*/*',
    '/salesChannel/editor/content/contentPage/*/*/*',
  ],
  tabBar: ['/salesChannel/editor/content/tabbar/*/*'],
  shoppingCart: ['/salesChannel/editor/content/shoppingCart/*/*'],
  promotion: ['/salesChannel/editor/content/promotion/*/*'],
  profile: ['/salesChannel/editor/content/profilepage/*/*'],
  appearance: ['/salesChannel/editor/content/appearance/*/*'],
  navigation: ['/salesChannel/editor/content/navigation/*/*'],
  header: ['/salesChannel/editor/content/header/*/*'],
  footer: ['/salesChannel/editor/content/footer/*/*'],
  megaMenu: ['/salesChannel/editor/content/megaMenu/*/*'],
  animation: ['/salesChannel/editor/content/animation/*/*'],
  button: ['/salesChannel/editor/content/button/*/*'],
  text: ['/salesChannel/editor/content/text/*/*'],
  productList: ['/salesChannel/products/*'],
  product: ['/salesChannel/products/link/*/*'],
  productContent: ['/salesChannel/products/content/*/*'],
  productAlias: [
    '/salesChannel/products/alias/*/*',
    '/salesChannel/products/alias/*/*/*',
  ],
  productCustomization: ['/salesChannel/products/customisation/*/*'],
  promotionTag: [
    '/salesChannel/promotionTag/editor/*/*',
    '/salesChannel/promotionTagList/*',
  ],
  maintenance: ['/salesChannel/maintenance/*'],
  collection: [
    '/salesChannel/collections/list/*',
    '/salesChannel/collections/editor/*/*',
  ],
  categoryProduct: ['/salesChannel/category/products/*'],
  categoryPage: ['/salesChannel/category/pages/*'],
  legalPage: [
    '/salesChannel/legalPage/list/*',
    '/salesChannel/legalPage/editor/*/*',
  ],
  tc: [
    '/salesChannel/termsAndCondition/list/*',
    '/salesChannel/termsAndCondition/editor/*/*',
  ],
  directDiscount: [
    '/salesChannel/discounts/directDiscount/editor/*/*',
    '/salesChannel/discounts/directDiscount/list/*',
  ],
  subscriptionBuy: [
    '/salesChannel/discounts/subscriptionBuy/editor/*/*',
    '/salesChannel/discounts/subscriptionBuy/list/*',
  ],
  giftPurchase: [
    '/salesChannel/discounts/giftPurchase/editor/*/*',
    '/salesChannel/discounts/giftPurchase/list/*',
  ],
  flashSale: [
    '/salesChannel/discounts/flashSale/editor/*/*',
    '/salesChannel/discounts/flashSale/list/*',
  ],
  voucher: [
    '/salesChannel/discounts/voucher/editor/*/*',
    '/salesChannel/discounts/voucher/list/*',
  ],
  settings: ['/salesChannel/setting/*/*', '/salesChannel/settings/*'],
};
export { storeDict, salesChannelDict, storeRoutes, salesChannelRoutes };
